import { render, staticRenderFns } from "./ComputersVerified.vue?vue&type=template&id=4ea97f5c&"
import script from "./ComputersVerified.vue?vue&type=script&lang=js&"
export * from "./ComputersVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports